module.exports = __webpack_public_path__ + "img/room09_whois.5a463b45.jpg";